
function useForecastUiData(forecastData = {}, weeklyData = {}, stockMonthlyData = [], stockWeeklyData = [], pastActualsCount = 0, forecastCount = 0, projectionCount = 0, driversMonthlyData = [], driversWeeklyData = [], inputsMonthlyData = [], inputsWeeklyData = [], allDefaultInputVals = {}, foreCastTertiaryMonthlyData = [], foreCastTertiaryWeeklyData = [], pastForecast = {}, projectedValues = [], editingInputsValues = [], week_after_launch = []) {
    console.log("values: ", editingInputsValues, projectedValues)

    const { primary = [], secondary = [], tertiary = [] } = forecastData;
    const { primary: wP = [], secondary: wS = [], tertiary: wT = [] } = weeklyData;

    console.log("projectionCount", foreCastTertiaryMonthlyData, foreCastTertiaryWeeklyData)

    console.log("pastforecast values state", pastForecast)
    // if (projectedValues !== null || projectedValues.length !== 0) {
    //     console.log("projected values from useForecastUidata", projectedValues)
    //     console.log("projectedvals from useuidata ", projectedValues?.input?.dbr_dos)
    // }
    // console.log(driversMonthlyData, driversWeeklyData)
    // console.log("alldefaultvls", allDefaultInputVals)
    console.log("projectedvaluues comming", projectedValues)

    let fillerForecast, emptyProjection;
    if (forecastCount > 0)
        fillerForecast = Array(forecastCount).fill(0);
    if (projectionCount > 0)
        emptyProjection = Array(projectionCount).fill(0)
    // console.log("from ui", forecastData,
    //     weeklyData)

    console.log("fillerforecast and emptyprojection", forecastCount, projectionCount)

    const weekAfterLaunch = Array.isArray(week_after_launch) ? week_after_launch.slice() : [];

    const defaultMonthlyCount = 12;
    const weeklyCount = pastActualsCount;
    const pastForecastCount = forecastCount;
    const projCount = projectionCount;

    // week after launch slices
    const monthlySeg = weekAfterLaunch.slice(0, defaultMonthlyCount);
    const weekActualsSeg = weekAfterLaunch.slice(defaultMonthlyCount, defaultMonthlyCount + weeklyCount);
    const pastForecastSeg = weekAfterLaunch.slice(defaultMonthlyCount + weeklyCount, defaultMonthlyCount + weeklyCount + pastForecastCount);
    const projectionSeg = weekAfterLaunch.slice(
        defaultMonthlyCount + weeklyCount + pastForecastCount,
        defaultMonthlyCount + weeklyCount + pastForecastCount + projCount
    );

    const consumed = defaultMonthlyCount + weeklyCount + pastForecastCount + projCount;
    let projectionFinal = projectionSeg;
    if (weekAfterLaunch.length > consumed) {
        const remaining = weekAfterLaunch.slice(consumed);
        projectionFinal = projectionSeg.concat(remaining);
        console.log("values: s", projectionFinal)
    }

    // week after launch slices [End]
    // comprehensive object for all the sections and their associated fields
    const forecastTableData = {
        kpi: {
            props: [
                { color: "blue", rowData: "Tertiary Vol", title: "tertiary", monthlyValues: tertiary, weeklyValues: wT, forecastValues: pastForecast ? pastForecast?.kpi?.forecasted_tertiary : fillerForecast, projectionValues: projectedValues?.kpi?.tertiary ?? emptyProjection },
                { color: "blue", rowData: "Secondary Vol", title: "secondary", monthlyValues: secondary, weeklyValues: wS, forecastValues: pastForecast ? pastForecast?.kpi?.forecasted_secondary : fillerForecast, projectionValues: projectedValues?.kpi?.secondary ?? emptyProjection },
                { color: "blue", rowData: "Primary Vol", title: "primary", monthlyValues: primary, weeklyValues: wP, forecastValues: pastForecast ? pastForecast?.kpi?.forecasted_primary : fillerForecast, projectionValues: projectedValues?.kpi?.primary ?? emptyProjection },
            ]
        },
        stock: {
            props: [
                {
                    color: "blue", title: "openingDBRStock", title2: "opening_dbr_stk", rowData: "Opening DBR Stk",
                    monthlyValues: stockMonthlyData.map(d => d.openingDBRStock ?? 0),
                    weeklyValues: stockWeeklyData.map(d => d.openingDBRStock ?? 0),
                    forecastValues: pastForecast ? pastForecast?.stock?.opening_dbr_stock : fillerForecast,
                    projectionValues: projectedValues?.stock?.opening_dbr_stk ?? emptyProjection
                },
                {
                    color: "blue", rowData: "Opening Retailer Stk", title: "openingRetailerStock", title2: "opening_retailer_stk",
                    monthlyValues: stockMonthlyData.map(d => d.openingRetailerStock ?? 0),
                    weeklyValues: stockWeeklyData.map(d => d.openingRetailerStock ?? 0),
                    forecastValues: pastForecast ? pastForecast?.stock?.opening_retailer_stock : fillerForecast,
                    projectionValues: projectedValues?.stock?.opening_retailer_stk ?? emptyProjection
                },
                {
                    color: "blue", rowData: "Opening Market Stk", title: "openingMarketStock", title2: "opening_market_stk",
                    monthlyValues: stockMonthlyData.map(d => d.openingMarketStock ?? 0),
                    weeklyValues: stockWeeklyData.map(d => d.openingMarketStock ?? 0),
                    forecastValues: pastForecast ? pastForecast?.stock?.opening_market_stock : fillerForecast,
                    projectionValues: projectedValues?.stock?.opening_market_stk ?? emptyProjection
                },
                {
                    color: "blue", rowData: "Closing DBR Stock", title: "closingDBRStock", title2: "dbr_stock_vol",
                    monthlyValues: stockMonthlyData.map(d => d.closingDBRStock ?? 0),
                    weeklyValues: stockWeeklyData.map(d => d.closingDBRStock ?? 0),
                    forecastValues: pastForecast ? pastForecast?.stock?.dbr_stock_vol : fillerForecast,
                    projectionValues: projectedValues?.stock?.dbr_stock_vol ?? emptyProjection
                },
                {
                    color: "blue", rowData: "Closing Retailer Stock", title: "closingRetailerStock", title2: "ret_stock_vol",
                    monthlyValues: stockMonthlyData.map(d => d.closingRetailerStock ?? 0),
                    weeklyValues: stockWeeklyData.map(d => d.closingRetailerStock ?? 0),
                    forecastValues: pastForecast ? pastForecast?.stock?.ret_stock_vol : fillerForecast,
                    projectionValues: projectedValues?.stock?.ret_stock_vol ?? emptyProjection
                },
                {
                    color: "blue", rowData: "Market Stock", title: "closingMarketStock", title2: "market_stock",
                    monthlyValues: stockMonthlyData.map(d => d.closingMarketStock ?? 0),
                    weeklyValues: stockWeeklyData.map(d => d.closingMarketStock ?? 0),
                    forecastValues: pastForecast ? pastForecast?.stock?.market_stock : fillerForecast,
                    projectionValues: projectedValues?.stock?.market_stock ?? emptyProjection
                },
                {
                    color: "blue", rowData: "Market DOS", title: "marketDOS", title2: "market_dos",
                    monthlyValues: stockMonthlyData.map(d => d.marketDOS ?? 0),
                    weeklyValues: stockWeeklyData.map(d => d.marketDOS ?? 0),
                    forecastValues: pastForecast ? pastForecast?.stock?.market_dos : fillerForecast,
                    projectionValues: projectedValues?.stock?.market_dos ?? emptyProjection
                }
            ]
        },
        forecastTertiary: {
            title: "Forecast Tertiary",
            props: [
                {
                    color: "blue", rowData: "Parameters", title: "parameter", title2: "parameter", monthlyValues: Array(foreCastTertiaryMonthlyData.length)?.fill(0),
                    weeklyValues: Array(pastActualsCount).fill(0),
                    forecastValues: fillerForecast,
                    projectionValues: projectedValues?.forecast_tertiary?.pilot ? projectedValues?.forecast_tertiary?.parameters : emptyProjection
                },
                {
                    color: "blue", rowData: "Pilot", title: "pilot", title2: "pilot", monthlyValues: Array(foreCastTertiaryMonthlyData.length)?.fill(0),
                    weeklyValues: Array(pastActualsCount).fill(0),
                    forecastValues: fillerForecast,
                    projectionValues: projectedValues?.forecast_tertiary?.pilot ? projectedValues?.forecast_tertiary?.pilot : emptyProjection
                },
                {
                    color: "blue", rowData: "National DRR", title: "national_drr", title2: "national_drr", monthlyValues: Array(foreCastTertiaryMonthlyData.length)?.fill(0),
                    weeklyValues: Array(pastActualsCount).fill(0),
                    forecastValues: fillerForecast,
                    projectionValues: projectedValues?.forecast_tertiary?.pilot ? projectedValues?.forecast_tertiary?.national : emptyProjection
                },
                {
                    color: "blue", rowData: "Activating Outlet", title: "ao", title2: "ao", monthlyValues: foreCastTertiaryMonthlyData, weeklyValues: foreCastTertiaryWeeklyData, forecastValues: pastForecast ? pastForecast?.forecast_tertiary
                        ?.activating_outlet.length === 0 ? fillerForecast : pastForecast?.forecast_tertiary
                        ?.activating_outlet : fillerForecast,
                    projectionValues: projectedValues?.forecast_tertiary?.pilot ? projectedValues?.forecast_tertiary?.activating_outlet : emptyProjection,
                }
            ]
        },
        drivers: {
            title: "Drivers",
            props: [
                {
                    color: "blue", rowData: "Stock/Outlet", title: "stock_per_outlet", title2: "stock_outlet", monthlyValues: driversMonthlyData?.stock_per_outlet ?? 0, weeklyValues: driversWeeklyData.stock_per_outlet ?? 0,
                    forecastValues: pastForecast ? pastForecast?.drivers?.stock_per_outlet : fillerForecast,
                    projectionValues: projectedValues?.drivers?.stock_outlet ?? emptyProjection

                },
                {
                    color: "blue", rowData: "AO/SO", title: "ao_per_so", title2: "ao_so", monthlyValues: driversMonthlyData.ao_per_so ?? 0, weeklyValues: driversWeeklyData?.ao_per_so ?? 0, forecastValues: pastForecast ? pastForecast?.drivers?.ao_per_so : fillerForecast,
                    projectionValues: projectedValues?.drivers?.ao_so ?? emptyProjection
                },
                {
                    color: "blue",
                    rowData: "Conversion",
                    title: "thruput",
                    title2: "throughput",
                    monthlyValues: driversMonthlyData.thruput ?? 0, weeklyValues: driversWeeklyData?.thruput ?? 0,
                    forecastValues: pastForecast ? pastForecast?.drivers?.throughput : fillerForecast,
                    projectionValues: projectedValues?.drivers?.throughput ?? emptyProjection
                },
                {
                    color: "blue", rowData: "WOD/AO", title: "wod_per_ao", title2: "wod_ao", monthlyValues: driversMonthlyData.wod_per_ao ?? 0, weeklyValues: driversWeeklyData?.wod_per_ao ?? 0, forecastValues: pastForecast ? pastForecast?.drivers?.wod_per_ao : fillerForecast,
                    projectionValues: projectedValues?.drivers?.wod_ao ?? emptyProjection
                },
                {
                    color: "blue", rowData: "T-Put", title: "tput", title2: "tput", monthlyValues: driversMonthlyData.tput ?? 0, weeklyValues: driversWeeklyData?.tput ?? 0, forecastValues: pastForecast ? pastForecast?.drivers?.tput : fillerForecast,
                    projectionValues: projectedValues?.drivers?.tput ?? emptyProjection
                },
                {
                    color: "blue", rowData: "Pilot Tertiary L7D-Sum", title: "pilotl7dsum", title2: "pilot_tertiary_l7d_sum", monthlyValues: driversMonthlyData.pilotl7dsum ?? 0, weeklyValues: driversWeeklyData?.pilotl7dsum ?? 0, forecastValues: pastForecast ? pastForecast?.drivers?.pilot_l7d_sum : fillerForecast,
                    projectionValues: projectedValues?.drivers?.pilot_tertiary_l7d_sum ?? emptyProjection
                },
                {
                    color: "blue", rowData: "Pilot Tertiary L7D-Avg", title: "pilotl7davg", title2: "pilot_tertiary_l7d_avg", monthlyValues: driversMonthlyData.pilotl7davg ?? 0, weeklyValues: driversWeeklyData?.pilotl7davg ?? 0, forecastValues: pastForecast ? pastForecast?.drivers?.pilot_l7_davg : fillerForecast,
                    projectionValues: projectedValues?.drivers?.pilot_tertiary_l7d_avg ?? emptyProjection
                },
                {
                    color: "blue", rowData: "National L7- DRR", title: "nationall7drr", title2: "national_l7_drr", monthlyValues: driversMonthlyData.nationall7drr ?? 0, weeklyValues: driversWeeklyData.nationall7drr ?? 0, forecastValues: pastForecast ? pastForecast?.drivers?.national_l7drr : fillerForecast,
                    projectionValues: projectedValues?.drivers?.national_l7_drr ?? emptyProjection
                },
                {
                    color: "blue",
                    rowData: "Week After Launch",
                    monthlyValues: monthlySeg ?? [],
                    weeklyValues: weekActualsSeg ?? [],
                    forecastValues: pastForecastSeg ?? [],
                    projectionValues: projectionSeg ?? []
                }
            ]
        },
        exposure: {
            title: "Exposure",
            props: [
                {
                    color: "blue", rowData: "Exposure", title: 'exposure', title2: 'exposure', monthlyValues: Array(foreCastTertiaryMonthlyData.length)?.fill(0),
                    weeklyValues: Array(pastActualsCount).fill(0), forecastValues: fillerForecast,
                    projectionValues: emptyProjection
                },
                {
                    color: "blue",
                    rowData: "Exposure DOS",
                    title: "exposure_dos", title2: "exposure_dos", monthlyValues: Array(foreCastTertiaryMonthlyData.length)?.fill(0),
                    weeklyValues: Array(pastActualsCount).fill(0), forecastValues: fillerForecast,
                    projectionValues: emptyProjection
                }
            ]
        },
        inputs: {
            title: "Input",
            props: [
                {
                    color: "blue",
                    rowData: "DBR DOS",
                    inputName: "dbr_dos",
                    monthlyValues: inputsMonthlyData?.dbr_dos ?? [],
                    weeklyValues: inputsWeeklyData?.dbr_dos ?? [],
                    forecastValues: allDefaultInputVals?.past_forecast?.dbr_dos ?? [],
                    projectionValues: editingInputsValues && editingInputsValues.length !== 0 ? editingInputsValues?.dbr_dos : projectedValues?.input?.dbr_dos ?? []
                },
                {
                    color: "blue",
                    rowData: "Ret DOS",
                    inputName: "ret_dos",
                    monthlyValues: inputsMonthlyData?.ret_dos ?? [],
                    weeklyValues: inputsWeeklyData?.ret_dos ?? [],
                    forecastValues: allDefaultInputVals?.past_forecast?.ret_dos ?? [],
                    projectionValues: editingInputsValues && editingInputsValues.length !== 0 ? editingInputsValues?.ret_dos : projectedValues?.input?.ret_dos ?? []
                },
                {
                    color: "blue",
                    rowData: "WOD",
                    inputName: "wod",
                    monthlyValues: inputsMonthlyData?.wod ?? [],
                    weeklyValues: inputsWeeklyData?.wod ?? [],
                    forecastValues: allDefaultInputVals?.past_forecast?.wod ?? [],
                    projectionValues: editingInputsValues && editingInputsValues.length !== 0 ? editingInputsValues?.wod : projectedValues?.input?.wod ?? []
                },
                {
                    color: "blue",
                    rowData: "PLC Factor",
                    inputName: "plc_factor",
                    monthlyValues: inputsMonthlyData?.plc_factor ?? [],
                    weeklyValues: inputsWeeklyData?.plc_factor ?? [],
                    forecastValues: allDefaultInputVals?.past_forecast?.plc_factor ?? [],
                    projectionValues: editingInputsValues && editingInputsValues.length !== 0 ? editingInputsValues?.plc_factor : projectedValues?.input?.plc_factor ?? []
                },
                {
                    color: "blue",
                    rowData: "Seasonality",
                    inputName: "seasonality",
                    monthlyValues: inputsMonthlyData?.seasonality ?? [],
                    weeklyValues: inputsWeeklyData?.seasonality ?? [],
                    forecastValues: allDefaultInputVals?.past_forecast?.seasonality ?? [],
                    projectionValues: editingInputsValues && editingInputsValues.length !== 0 ? editingInputsValues?.seasonality : projectedValues?.input?.seasonality ?? []
                },
                {
                    color: "blue",
                    rowData: "Pilot Weightage",
                    inputName: "pilot_weightage",
                    monthlyValues: inputsMonthlyData?.pilot_weightage ?? [],
                    weeklyValues: inputsWeeklyData?.pilot_weightage ?? [],
                    forecastValues: allDefaultInputVals?.past_forecast?.pilot_weightage ?? [],
                    projectionValues: editingInputsValues && editingInputsValues.length !== 0 ? editingInputsValues?.pilot_weightage : projectedValues?.input?.pilot_weightage ?? []
                },
                {
                    color: "blue",
                    rowData: "National Weightage",
                    inputName: "national_weightage",
                    monthlyValues: inputsMonthlyData?.national_weightage ?? [],
                    weeklyValues: inputsWeeklyData?.national_weightage ?? [],
                    forecastValues: allDefaultInputVals?.past_forecast?.national_weightage ?? [],
                    projectionValues: editingInputsValues && editingInputsValues.length !== 0 ? editingInputsValues?.national_weightage : projectedValues?.input?.national_weightage ?? []
                },
                {
                    color: "blue",
                    rowData: "Parameters Weightage",
                    inputName: "parameters_weightage",
                    monthlyValues: inputsMonthlyData?.parameters_weightage ?? [],
                    weeklyValues: inputsWeeklyData?.parameters_weightage ?? [],
                    forecastValues: allDefaultInputVals?.past_forecast?.parameters_weightage ?? [],
                    projectionValues: editingInputsValues && editingInputsValues.length !== 0 ? editingInputsValues?.parameters_weightage : projectedValues?.input?.parameters_weightage ?? []
                },
                {
                    color: "blue",
                    rowData: "Stocking Outlet",
                    inputName: "stocking_outlet",
                    monthlyValues: inputsMonthlyData?.stocking_outlet ?? [],
                    weeklyValues: inputsWeeklyData?.stocking_outlet ?? [],
                    forecastValues: allDefaultInputVals?.past_forecast?.stocking_outlet ?? [],
                    projectionValues: editingInputsValues && editingInputsValues.length !== 0 ? editingInputsValues?.stocking_outlet : projectedValues?.input?.stocking_outlet ?? []
                },
                {
                    color: "blue",
                    rowData: "Activating Outlet",
                    inputName: "activating_outlet",
                    monthlyValues: inputsMonthlyData?.activating_outlet ?? [],
                    weeklyValues: inputsWeeklyData?.activating_outlet ?? [],
                    forecastValues: allDefaultInputVals?.past_forecast?.activating_outlet ?? [],
                    projectionValues: editingInputsValues && editingInputsValues.length !== 0 ? editingInputsValues?.activating_outlet : projectedValues?.input?.activating_outlet ?? []
                }
            ]
        }
    }
    return forecastTableData;
}

export default useForecastUiData;